// AI-CONTEXT: See docs/features/participatieladder-2026-3.md
// AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading

/** De titel waaronder de geboortedatum in de tab Gegevens (`PersonaData`) staat. */
export const BIRTH_DATE_TITLE = 'Geboortedatum'

/**
 * De geboortedatum per persona uit `PersonaData`-rijen, voor de
 * leeftijdsovergang van parameterset 2026.3 (besluit D5). Per persona telt de
 * eerste niet-lege waarde. Geen array (de read loopt nog) → null, zodat
 * 'nog niet geladen' niet leest als 'geen geboortedatum'.
 *
 * @param {Array<{PersonaID?: string, Title?: string, Value?: string}>|*} rows
 * @returns {Object<string, string>|null} PersonaID → ruwe waarde
 */
const birthDatesByPersona = (rows) => {
    if (!Array.isArray(rows)) return null
    return rows.reduce((acc, row) => {
        const value = typeof row?.Value === 'string' ? row.Value.trim() : ''
        if (row?.Title !== BIRTH_DATE_TITLE || !value || !row.PersonaID || acc[row.PersonaID]) return acc
        return { ...acc, [row.PersonaID]: value }
    }, {})
}

/**
 * De context voor de leeftijdsovergang bij de HUIDIGE waarde van een persona:
 * zijn geboortedatum en de bewerkdatum van beide meetmomenten (besluit P2).
 * Eén plek voor het tabblad, het dashboard en de nachtrun.
 *
 * @param {{ ID?: string, Participation?: { t0?: { updatedAt?: * }, t1?: { updatedAt?: * } } }} persona
 * @param {Object<string, string>|null|undefined} birthDates - uit birthDatesByPersona
 * @returns {{ birthDate: string|undefined, t0Date: *, t1Date: * }}
 */
export const currentParticipationContext = (persona, birthDates) => ({
    birthDate: (birthDates && persona?.ID && birthDates[persona.ID]) || undefined,
    t0Date: persona?.Participation?.t0?.updatedAt,
    t1Date: persona?.Participation?.t1?.updatedAt,
})

export default birthDatesByPersona
